<!--
* @description  快递查价
* @fileName  index
* @author userName
* @date 2024-01-04 16:14:28
!-->
<template>
  <div id="index" :class="['checkPriceIndex', { p24: isClickQuery }]">
    <by-form
      ref="exp"
      :model="form"
      :rules="rules"
      submit
      style="display: flex; flex-wrap: wrap"
      :class="[{ 'checkPrice-form': isClickQuery }]"
    >
      <div class="checkPrice-form-item flex">
        <input-template
          style="width: 272px; margin: 4px; padding: 4px"
          :active-border="OriginIsFocus"
          :is-padding="false"
        >
          <ByFormItem
            ref="OriginByFormItem"
            prop="start"
            class="ByFormItem"
            :label-icon="false"
            label-icon-name="zuobiao1"
            :label-icon-size="16"
            label="起运地"
            @click.native.stop="focusShow('origin')"
          >
            <Origin
              ref="origin"
              placeholder="您要从哪里发货?"
              search-keys-type="Origin"
              width="260"
              @blur="
                () => {
                  $refs.OriginByFormItem.error = !OriginSuccess ? true : false;
                }
              "
              @checkprice="checkprice"
              @getFocusStatus="
                (val) => {
                  OriginIsFocus = val;
                }
              "
              @next="originNext"
              @typeChange="originTypeChange"
            />
          </ByFormItem>
        </input-template>
        <div class="" />
        <div class="split-line">
          <div class="split-line-inner" />
          <img
            style="margin-left: -40px; position: relative; left: 20px;"
            src="@/assets/img/client/check/ic_arrow.png"
            width="40"
            height="40"
            alt="arrow"
          >
        </div>

        <input-template
          style="width: 272px; margin: 4px; padding: 4px"
          :active-border="DestinationIsFocus"
          :is-padding="false"
        >
          <ByFormItem
            ref="DestinationByFormItem"
            prop="start"
            class="ByFormItem Destination"
            :label-icon="false"
            label-icon-name="zuobiao1"
            :label-icon-size="16"
            label="目的地"
            @click.native.stop="focusShow('Destination')"
          >
            <Destination
              ref="Destination"
              placeholder="您要运送到哪里？"
              search-keys-type="Destination"
              width="260"
              @blur="
                () => {
                  $refs.DestinationByFormItem.error = !DestinationSuccess
                    ? true
                    : false;
                }
              "
              @checkprice="checkprice"
              @getFocusStatus="
                (val) => {
                  DestinationIsFocus = val;
                }
              "
              @next="destNext"
              @typeChange="destTypeChange"
            />
          </ByFormItem>
        </input-template>
      </div>
      <div class="checkPrice-form-item margin-left_8">
        <input-template
          style="width: 248px; margin: 4px; padding: 4px"
          :active-border="LoadIsFocus"
          :is-padding="false"
        >
          <ByFormItem
            ref="LoadByFormItem"
            prop="Load"
            class="ByFormItem Load"
            :label-icon="false"
            label-icon-name="zuobiao1"
            :label-icon-size="16"
            label="货物信息"
            @click.native.stop="focusShow('Load')"
          >
            <Load
              ref="Load"
              placeholder="您要运送什么？"
              search-keys-type="Load"
              width="236"
              @blur="
                () => {
                  $refs.LoadByFormItem.error = !LoadSuccess ? true : false;
                }
              "
              @getFocusStatus="
                (val) => {
                  LoadIsFocus = val;
                }
              "
              @next="loadNext"
            />
          </ByFormItem>
        </input-template>
      </div>
      <div class="checkPrice-form-item margin-left_8">
        <input-template
          style="width: 288px; margin: 4px; padding: 4px"
          :active-border="GoodsFocus"
          :is-padding="false"
        >
          <ByFormItem
            ref="GoodsByFormItem"
            prop="Goods"
            class="ByFormItem Goods"
            :label-icon="false"
            label-icon-name="zuobiao1"
            :label-icon-size="16"
            label="品名、货值和货好时间"
            @click.native.stop="focusShow('Goods')"
          >
            <Goods
              ref="Goods"
              placeholder="告诉我们您的商品信息"
              search-keys-type="Goods"
              width="276"
              :dest-type="inputData.DestinationType"
              @blur="
                () => {
                  $refs.GoodsByFormItem.error = !GoodsSuccess ? true : false;
                }
              "
              @getFocusStatus="
                (val) => {
                  GoodsFocus = val;
                }
              "
              @next="goodsNext"
            />
          </ByFormItem>
        </input-template>
      </div>
      <button
        v-if="!isClickQuery"
        type="button"
        :class="{
          'by-check-button margin-left_8': true,
          complete:
            OriginSuccess && DestinationSuccess && LoadSuccess && GoodsSuccess,
          'no-drop': !(
            OriginSuccess &&
            DestinationSuccess &&
            LoadSuccess &&
            GoodsSuccess
          ),
        }"
        :disabled="
          !(OriginSuccess && DestinationSuccess && LoadSuccess && GoodsSuccess)
        "
        @click="queryPrice"
      >
        <i class="el-icon-search search-icon" />
      </button>
    </by-form>
  </div>
</template>

<script>
import { GetSysConfig } from '@/api/base.js'
import { getConfig, setConfig } from '@/utils/auth.js'
import { QueryPrice } from '@/api/checkPrice.js'
import { getCookie } from '@/utils/cookiejs'
import Origin from '@/client/home/checkPrice/Exp/origin.vue'
import Destination from '@/client/home/checkPrice/Exp/destination.vue'
import Load from '@/client/home/checkPrice/load.vue'
import Goods from '@/client/home/checkPrice/goods.vue'
import InputTemplate from '@/client/home/byForm/InputTemplate.vue'
import ByFormItem from '@/client/home/byForm/ByFormItem.vue'
import ByForm from '@/client/home/byForm/ByForm.vue'
export default {
  name: 'Index',
  components: {
    // 组件的引用
    InputTemplate,
    ByFormItem,
    Origin,
    Destination,
    ByForm,
    Load,
    Goods
  },
  props: {
    // 父辈向子辈传参
  },
  data() {
    return {
      OriginIsFocus: false, // 起始地目的地输入框高亮
      DestinationIsFocus: false,
      LoadIsFocus: false,
      GoodsFocus: false,
      form: {},
      rules: {},
      OriginSuccess: false, // orgin信息填写成功
      DestinationSuccess: false, // Destination信息填写成功
      LoadSuccess: false, // Load信息填写成功
      GoodsSuccess: false, // Goods信息填写成功
      isClickQuery: false, // 是否点击查价按钮
      isSingleEntry: true,
      isAnnual: false,
      loadInfo: {},
      originInfo: {},
      destInfo: {},
      goodsInfo: {},
      inputData: {
        OriginType: '',
        OriginCountryId: '',
        OriginCountryCode: '',
        OriginCityId: '',
        OriginAddressCode: '',
        OriginAirportId: '',
        OriginPortId: '',
        OriginPortType: '',
        OriginZipCode: '',
        DestinationType: 4,
        DestinationCountryId: '',
        DestinationCountryCode: '',
        DestinationCityId: '',
        DestinationAddressCode: '',
        DestinationZipCode: '',
        DestinationAirportId: '',
        DestinationPortId: '',
        DestinationWarehouseId: '',
        DestinationPortType: '',
        FbaWarehouseCode: '',
        TotalQuantity: '',
        TotalWeight: '',
        TotalVolume: '',
        GoodsValue: '',
        GoodsName: '',
        GoodsReadyTime: '',
        GoodsType: '',
        IsOriginCharges: true,
        IsDestinationCharges: true,
        IsLiftgatePickup: undefined,
        IsLiftgateDelivery: undefined,
        IsInsurance: true,
        IsCustomsBrokerage: true,
        IsBond: true,
        BondType: true,
        IsKnown: false,
        CalculationSource:0,
        SortType: 0
      },
      results: [],
      isEdit: false,
      isQuick: false,
      step: undefined,
      sysConfig: {},
      singleBondFee: undefined
    }
  },
  computed: {
    // 计算属性
  },
  watch: {
    // 监测变化
  },
  created() {
    // 实例被创建之后执行代码
	this.sysConfig = getConfig() || {}
    this.initSysConfig()
  },
  mounted() {
    // 页面进入时加载内容
  },
  methods: {
    originTypeChange(type) {
      this.inputData.OriginType = type
    },
    destTypeChange(type) {
      this.inputData.DestinationType = type
    },
    initSysConfig() {
      GetSysConfig().then(res => {
        if (res.code === 200) {
			setConfig(res.data)
			this.sysConfig = res.data
        }
      })
    },
    init(step) {
      this.step = step
      if (step === 1) {
        this.isClickQuery = true
      } else {
        this.isClickQuery = false
      }
    },
    isAnnualChange(val) {
      this.isSingleEntry = false
      if (!val) {
        this.isAnnual = true
      }
    },
    isSingleEntryChange(val) {
      this.isAnnual = false
      if (!val) {
        this.isSingleEntry = true
      }
    },
    originNext(data) {
      this.originInfo = data
      this.$refs.OriginByFormItem.success = true
      this.$refs.OriginByFormItem.error = false
      this.OriginSuccess = true
      if (!this.isClickQuery && !this.isEdit && !this.isQuick) {
        this.$refs.Destination.focusInput()
      }
    },
    destNext(data) {
      this.destInfo = data
      this.$refs.DestinationByFormItem.success = true
      this.$refs.DestinationByFormItem.error = false
      this.DestinationSuccess = true
      if (!this.isClickQuery && !this.isEdit && !this.isQuick) {
        this.$refs.Load.focusInput()
      }
    },
    loadNext(loadInfo) {
      this.loadInfo = loadInfo
      this.$refs.LoadByFormItem.success = true
      this.$refs.LoadByFormItem.error = false
      this.LoadSuccess = true
      if (!this.isClickQuery && !this.isEdit && !this.isQuick) {
        this.$refs.Goods.focusInput()
      }
    },
    goodsNext(data) {
      this.goodsInfo = data
      this.$refs.GoodsByFormItem.success = true
      this.$refs.GoodsByFormItem.error = false
      this.GoodsSuccess = true
    },
    // 方法
    // 组件点击事件
    focusShow(ref) {
      this.$refs[ref].focusInput()
      const list = ['origin', 'Destination', 'Load', 'Goods']
      list.forEach((item) => {
        console.log(item)
        if (item != ref) {
          this.$refs[item].closePanel()
        }
      })
    },
    queryPrice() {
      if (
        this.OriginSuccess &&
        this.DestinationSuccess &&
        this.LoadSuccess &&
        this.GoodsSuccess
      ) {
        this.inputData.OriginType = this.originInfo.Type
        this.inputData.OriginCountryId = this.originInfo.Country
        this.inputData.OriginCountryCode = this.originInfo.CountryCode
        this.inputData.OriginAddressCode = this.originInfo.AddressCode
        if (this.originInfo.Type === 1) {
          // portType 1 港口 2 机场
          if (this.originInfo.PortType === 1) {
            this.inputData.OriginPortId = this.originInfo.Address
          } else {
            this.inputData.OriginAirportId = this.originInfo.Address
          }
          this.inputData.OriginPortType = this.originInfo.PortType
        } else {
          this.inputData.OriginCityId = this.originInfo.Address
          this.inputData.OriginZipCode = this.originInfo.ZipCode
        }
        this.inputData.DestinationType = this.destInfo.Type
        this.inputData.DestinationCountryId = this.destInfo.Country
        this.inputData.DestinationCountryCode = this.destInfo.CountryCode
        this.inputData.DestinationAddressCode = this.destInfo.AddressCode
        if (this.destInfo.Type === 1) {
          if (this.destInfo.PortType === 1) {
            this.inputData.DestinationPortId = this.destInfo.Address
          } else {
            this.inputData.DestinationAirportId = this.destInfo.Address
          }
          this.inputData.OriginPortType = this.originInfo.PortType
        } else if (this.destInfo.Type === 3) {
          this.inputData.FbaWarehouseCode = this.destInfo.Address
        } else {
          this.inputData.DestinationCityId = this.destInfo.Address
          this.inputData.DestinationZipCode = this.destInfo.ZipCode
        }
        this.inputData.TotalQuantity = this.loadInfo.quantity
        this.inputData.TotalWeight = this.loadInfo.weight
        this.inputData.TotalVolume = this.loadInfo.volume
        this.inputData.GoodsValue = this.goodsInfo.goodsValue
        this.inputData.GoodsName = this.goodsInfo.goodsName
        this.inputData.GoodsType = this.goodsInfo.goodsType
        this.inputData.GoodsReadyType = this.goodsInfo.goodsReadyTime
        var goodsReady = new Date()
        if (this.goodsInfo.goodsReadyTime == 1) {
          goodsReady.setDate(goodsReady.getDate() + 1)
        } else if (this.goodsInfo.goodsReadyTime == 2) {
          goodsReady.setDate(goodsReady.getDate() + 1)
        } else if (this.goodsInfo.goodsReadyTime == 3) {
          goodsReady.setDate(goodsReady.getDate() + 15)
        }
        this.inputData.GoodsReadyTime = goodsReady
      }
      console.log(this.inputData)
      if (this.inputData.IsLiftgatePickup == undefined) {
        if (this.inputData.OriginType == 3) {
          this.inputData.IsLiftgatePickup = true
        } else {
          this.inputData.IsLiftgatePickup = false
        }
      }
      if (this.inputData.IsLiftgateDelivery == undefined) {
        if (this.inputData.DestinationType == 4) {
          this.inputData.IsLiftgateDelivery = true
        } else {
          this.inputData.IsLiftgateDelivery = false
        }
      }
      this.isClickQuery = true
      this.singleBondFee =
        this.inputData.GoodsValue * this.sysConfig.singleBondFee
      if (this.singleBondFee < this.sysConfig.singleBondFeeMin) {
        this.singleBondFee = this.sysConfig.singleBondFeeMin
      }
      this.$emit('step', true, 1) // 显示true进度条  1：第二条
      this.getResults()
    },
    getResults() {
      var cookie = getCookie('token')
      if (!cookie) {
        this.$store.commit('user/DIALOG_VISIBLE', true)
        return
      }
      if (this.inputData.IsBond) {
        if (this.isAnnual) {
          this.inputData.BondType = 2
        } else {
          this.inputData.BondType = 1
        }
      } else {
        this.inputData.BondType = 0
      }
      if (!Array.isArray(this.inputData.GoodsType)) {
        this.inputData.GoodsType = [this.inputData.GoodsType]
      }
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
        customClass: 'is-loading-style'
      })
	  this.inputData.BusinessType = 1
    this.inputData.CalculationSource=1
      QueryPrice(this.inputData).then((res) => {
        if (res.code === 200) {
          loading.close()
          this.isClickQuery = false
          this.isEdit = true
          localStorage.setItem('queryInput', JSON.stringify(this.inputData))
          localStorage.setItem('queryResult', JSON.stringify(res.data))
          this.$emit('step', true, 2, res.data, this.inputData) // 显示true进度条  1：第二条
        }
      })
    },
    checkprice(inputdata, isOpen = true) {
      this.isQuick = true
      var originData = {
        Type: inputdata.OriginType,
        Country: inputdata.OriginCountryId
      }
      if (inputdata.OriginType === 1) {
        if (inputdata.OriginPortId) {
          originData.Address = inputdata.OriginPortId
        } else {
          originData.Address = inputdata.OriginAirportId
        }
      } else {
        originData.Address = inputdata.OriginCityId
        originData.ZipCode = inputdata.OriginZipCode
      }
      this.$refs.origin.init(originData)

      var destData = {
        Type: inputdata.DestinationType,
        Country: inputdata.DestinationCountryId
      }
      this.inputData.DestinationType = inputdata.DestinationType
      if (inputdata.DestinationType === 1) {
        if (inputdata.DestinationPortId) {
          destData.Address = inputdata.DestinationPortId
        } else {
          destData.Address = inputdata.DestinationAirportId
        }
      } else if (inputdata.DestinationType === 3) {
        destData.Address = inputdata.FbaWarehouseCode
      } else {
        destData.Address = inputdata.DestinationCityId
        destData.ZipCode = inputdata.DestinationZipCode
      }
      this.$refs.Destination.init(destData)
      var loadData = {
        quantity: inputdata.TotalQuantity,
        volume: inputdata.TotalVolume,
        weight: inputdata.TotalWeight,
        volumeUnit: 'CBM',
        weightUnit: 'KG'
      }
      this.$refs.Load.init(loadData, 1)
      if (isOpen) {
        this.focusShow('Goods')
      }
    }
  }
}
</script>
<style scoped lang="scss">
@font-face {
  font-family: 'D-DINExp';
  src: url('../../../../assets/font/D-DINExp.otf') format('opentype');
}

.p24 {
  padding: 24px;
}

.checkPriceIndex {
  width: 1200px;
  min-height: 64px;
  // background: #ffffff;
  border-radius: 8px;

  .checkPrice-form {
    border-radius: 8px;
    // border: 1px solid #dddddd;
  }

  .checkPrice-form-item {
    height: 64px;
    background: #ffffff;
    box-shadow: 0px 24px 24px 0px rgba(88, 115, 195, 0.08),
      0px 8px 16px 0px rgba(88, 115, 195, 0.08);
    border-radius: 10px;
  }

  .ByFormItem {
    padding: 4px 8px;
    height: 56px;

    ::v-deep .form-item__label {
      padding-top: 6px;
      font-size: 12px;
      font-family: D-DINExp, D-DINExp;
      font-weight: bold;
      line-height: 17px;
      color: #333333;
    }
  }

  .split-line {
    margin: 12px 0 0 -40px;
    position: relative;
    left: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;

    .split-line-inner {
      width: 1px;
      height: 40px;
      background: rgba(221,221,221,0.56);
    }
  }

  .Destination {
    ::v-deep .by-panel {
      left: 283px;
    }
  }

  .Load {
    ::v-deep .by-panel {
      width: 724px;
      left: 474px;
    }
  }

  .Goods {
    ::v-deep .by-panel {
      width: 800px;
      left: 398px;
    }
  }

  .by-check-button {
    width: 64px;
    height: 64px;
    background: linear-gradient(89deg, #6392ff 0%, #3370ff 100%);
    box-shadow: 0px 24px 24px 0px rgba(88, 115, 195, 0.08),
      0px 8px 16px 0px rgba(88, 115, 195, 0.08);
    border-radius: 8px;
    border: none;
    font-size: 24px;

    .search-icon {
      color: #ffffff;
    }
  }

  .complete {
    // background: #e95506;
    cursor: pointer;
  }

  .no-drop {
    cursor: no-drop;
  }

  .expand-price-dialog {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 2000;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(0, 0, 0, 0.5);

    .expand-price {
      text-align: left;
      width: 920px;
      padding: 0 24px;
      background: #ffffff;
      border-radius: 8px;
      box-sizing: border-box;

      .e-p-title {
        padding: 16px 0px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 14px;
        color: #333333;
        line-height: 24px;
        text-align: left;
        font-style: normal;
        border-bottom: 1px solid #ebebeb;
      }

      .e-p-tip {
        margin-top: 8px;
        height: 40px;
        background: rgba(239, 10, 10, 0.04);
        border-radius: 4px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 13px;
        color: #ef0a0a;
        text-align: left;
        font-style: normal;
        line-height: 40px;
        padding: 0 8px;
      }

      .switch-main {
        .switch-card {
          display: flex;
          align-items: stretch; // 垂直方向，子元素左右等高
          flex-flow: row wrap; // 以行排列 并且允许换行
          align-content: flex-start;

          // .switch-l:nth-child(2n+1) {
          .switch-card-l {
            width: 40%;
          }

          //.switch-l:nth-child(2n) {
          .switch-card-r {
            width: 60%;
          }

          .flex1 {
            display: flex;
          }

          .switch-l {
            ::v-deep .el-switch__label,
            .is-active {
              font-family: PingFangSC, PingFang SC;
              font-weight: 400;
              font-size: 13px;
              color: #333333;
              line-height: 18px;
              text-align: left;
              font-style: normal;
            }

            .mb45 {
              margin-bottom: 45px;
            }

            p {
              font-family: PingFangSC, PingFang SC;
              font-weight: 550;
              font-size: 14px;
              color: #333333;
              line-height: 20px;
              text-align: left;
              font-style: normal;
            }

            div {
              margin: 5px 0;
            }

            .active-class {
              background: rgba(2, 127, 252, 0.04) !important;
              border-radius: 8px;
              border: 1px solid #3370ff !important;
            }

            .wenhao-tip {
              display: inline-block;
              margin-left: 5px;
              font-size: 12px;
              width: 12px;
              height: 12px;
              border: 1px solid #333333;
              color: #333333;
              border-radius: 50%;

              &:hover {
                border: 1px solid #3370ff;
                color: #3370ff;
              }

              div {
                margin: 0 !important;
                text-align: center !important;
              }
            }

            .switch-card-left {
              width: 297px;
              height: 106px;
              background: rgba(221, 221, 221, 0.24);
              border-radius: 8px;
              border: 1px solid rgba(170, 170, 170, 0);
              padding: 16px;
              margin-right: 16px;

              .first-line {
                display: flex;
                justify-content: space-between;
                margin: 0px;

                .el-checkbox-style {
                  margin: 0px 0px;
                  display: flex;
                }

                .el-checkbox-style ::v-deep .el-checkbox {
                  .el-checkbox__inner {
                    width: 16px;
                    height: 16px;

                    &::after {
                      height: 8px;
                      left: 4.5px;
                    }
                  }

                  .el-checkbox__label {
                    font-family: PingFangSC, PingFang SC;
                    font-weight: 600;
                    font-size: 13px;
                    color: #333333;
                    line-height: 18px;
                    text-align: left;
                    font-style: normal;
                  }
                }

                .el-checkbox-style ::v-deep .is-checked {
                  .el-checkbox__inner {
                    border-color: #3370ff;
                    background: #3370ff;
                  }
                }

                div:nth-of-type(2) {
                  margin: 0px;
                  font-size: 16px;
                  font-family: D-DINExp;
                  font-weight: normal;

                  span:nth-of-type(1) {
                    color: #aaaaaa;
                  }

                  span:nth-of-type(1) {
                    color: #ef0a0a;
                  }

                  span:nth-of-type(2) {
                    color: #ef0a0a;
                  }
                }
              }

              .two-line {
                margin-top: 10px;
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                font-size: 12px;
                color: #333333;
                line-height: 17px;
                text-align: left;
                font-style: normal;
              }
            }
          }
        }
      }

      .expand-price-button {
        text-align: center;

        button {
          outline: none;
          border: none;
          width: 288px;
          height: 40px;
          background: #3370ff;
          border-radius: 8px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          font-size: 16px;
          color: #ffffff;
          text-align: center;
          font-style: normal;
          line-height: 40px;
          cursor: pointer;
          margin: 40px 0;
        }
      }
    }
  }
}
</style>
